import { Navigate, Outlet } from "react-router-dom";
import { Cargando } from "../components/Cargando";
import { useAuthSuperadmin } from "./SuperadminAuthContext";

export function SuperadminRutaProtegida() {
  const { superadmin, cargandoInicial } = useAuthSuperadmin();

  if (cargandoInicial) {
    return (
      <div className="flex h-screen items-center justify-center">
        <Cargando texto="Verificando sesión de plataforma..." />
      </div>
    );
  }

  if (!superadmin) {
    return <Navigate to="/superadmin/login" replace />;
  }

  return <Outlet />;
}
